import React 			from 'react';
import PropTypes 	from 'prop-types';

import BLComponent from '../core/_BLComponent.jsx'


export default class ReactionBar extends BLComponent {
	constructor(props) {
		super(props);

		this.state = {
				reactions: {
						heart: this.props.reactions ? this.props.reactions.heart : 0
					,	thumbsUp: this.props.reactions ? this.props.reactions.thumbsUp : 0		
					,	eyes: this.props.reactions ? this.props.reactions.eyes : 0		
					,	joy: this.props.reactions ? this.props.reactions.joy : 0		
					,	tada: this.props.reactions ? this.props.reactions.tada : 0		
				}
			,	myVote: this.props.myVote || 0
			,	isVoting: false
		};

	}

	componentDidUpdate(prevProps, prevState, snapshot)
	{
		super.componentDidUpdate( prevProps, prevState, snapshot );

		if(prevState.reactions != this.props.reactions && this.props.reactions != null)
		{
			this.setState({reactions: this.props.reactions})
		}
		if(prevState.myVote != this.props.myVote)
		{
			this.setState({myVote: this.props.myVote})
		}
	}

	render() {
		const {classes = '', data} = this.props;

		return (
			<ul className={"reaction-bar " + classes}>
				<li className={"reaction-bar__item reaction-bar__item--heart" + (this.state.myVote == 1 ? ' reaction-bar__item--active' : '')}>
					<button className="reaction-bar__btn" onClick={() => this.recordResponse(1)} disabled={this.state.isVoting}>
						<div className="reaction-bar__icon"><span className="reaction-bar__icon-internal">❤️</span></div>
						{this.state.reactions.heart ? <span className="reaction-bar__count">{this.state.reactions.heart}</span> : null}
					</button>
				</li>
				<li className={"reaction-bar__item reaction-bar__item--thumb-up" + (this.state.myVote == 2 ? ' reaction-bar__item--active' : '')}>
					<button className="reaction-bar__btn" onClick={() => this.recordResponse(2)} disabled={this.state.isVoting}>
						<div className="reaction-bar__icon"><span className="reaction-bar__icon-internal">&#x1F44D;</span></div>
						{this.state.reactions.thumbsUp ? <span className="reaction-bar__count">{this.state.reactions.thumbsUp}</span> : null}
					</button>
				</li>
				<li className={"reaction-bar__item reaction-bar__item--eyes" + (this.state.myVote == 3 ? ' reaction-bar__item--active' : '')}>
					<button className="reaction-bar__btn" onClick={() => this.recordResponse(3)} disabled={this.state.isVoting}>
						<div className="reaction-bar__icon"><span className="reaction-bar__icon-internal">&#x1F440;</span></div>
						{this.state.reactions.eyes ? <span className="reaction-bar__count">{this.state.reactions.eyes}</span> : null}
					</button>
				</li>
				<li className={"reaction-bar__item reaction-bar__item--joy" + (this.state.myVote == 4 ? ' reaction-bar__item--active' : '')}>
					<button className="reaction-bar__btn" onClick={() => this.recordResponse(4)} disabled={this.state.isVoting}>
						<div className="reaction-bar__icon"><span className="reaction-bar__icon-internal">&#x1F602;</span></div>
						{this.state.reactions.joy ? <span className="reaction-bar__count">{this.state.reactions.joy}</span> : null}
					</button>
				</li>
				<li className={"reaction-bar__item reaction-bar__item--tada" + (this.state.myVote == 5 ? ' reaction-bar__item--active' : '')}>
					<button className="reaction-bar__btn" onClick={() => this.recordResponse(5)} disabled={this.state.isVoting}>
						<div className="reaction-bar__icon"><span className="reaction-bar__icon-internal">&#x1F389;</span></div>
						{this.state.reactions.tada ? <span className="reaction-bar__count">{this.state.reactions.tada}</span> : null}
					</button>
				</li>
			</ul>
		);
	}

	recordResponse(response) {
		this.setState({isVoting: true})
		if(blapp.session.isLoggedIn())
			this.props.recordResponse(response, () => this.setState({isVoting: false}))
		else
		{
		blapp.refs.get( "header" ).showLogin(
			() =>
			{
				if( blapp.session.isLoggedIn() )
					this.props.recordResponse(response, () => this.setState({isVoting: false}))
				else
					this.setState({isVoting: false})
			}
		);
		}

	}
}

ReactionBar.propTypes = {
		classes: PropTypes.string
}